import {inject, Injectable} from '@angular/core';
import {PrimusRouteService} from '../core/primus-route.service';
import {contentListChoice, ContentListChoice, parseContentListChoice} from './content-list-view';

@Injectable({
  providedIn: 'root'
})
export class ContentListChoiceService {
  private readonly primusRoute = inject(PrimusRouteService);

  remember(viewName: string | undefined, templateId: string | undefined): void {
    const storage = this.storage();
    if (!storage) {
      return;
    }
    const choice = contentListChoice(viewName, templateId);
    const key = this.storageKey();
    if (!choice.viewName && !choice.templateId) {
      storage.removeItem(key);
      return;
    }
    storage.setItem(key, JSON.stringify(choice));
  }

  saved(): ContentListChoice {
    const storage = this.storage();
    if (!storage) {
      return {};
    }
    return parseContentListChoice(storage.getItem(this.storageKey()));
  }

  private storageKey(): string {
    const artifactId = this.primusRoute.params?.artifactId;
    const owner = typeof artifactId === 'string' && artifactId ? artifactId : 'page';
    return 'primus.contentListChoice.' + owner;
  }

  private storage(): Storage | undefined {
    if (typeof sessionStorage === 'undefined') {
      return undefined;
    }
    return sessionStorage;
  }
}
